import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private sidebarOpen = new BehaviorSubject<boolean>(
    typeof window === 'undefined' || window.innerWidth >= 800
  );
  sidebarOpen$ = this.sidebarOpen.asObservable();

  toggleSidebar() {
    // Sidebar is always open on desktop; no-op
    if (window.innerWidth < 800) {
      this.sidebarOpen.next(!this.sidebarOpen.value);
    }
  }

  openSidebar() {
    this.sidebarOpen.next(true);
  }
}
